import { useContext } from 'react';

import { ModalsStateContext } from './modals.context';

export const ModalsOutlet = () => {
    const modals = useContext(ModalsStateContext);

    return (
        <>
            {modals.map(modal => {
                return (
                    <modal.component key={modal.id} onClose={modal.onClose} show {...modal.props} />
                );
            })}
        </>
    );
};
